(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .factory('MetricConfig', MetricConfig);

  // @ngInject
  function MetricConfig($translate, percentFilter, numberFilter) {

    var defaultXFormat = d3.time.format.multi([
      ['%-I:%M %p', function (d) { return d.getMinutes(); }],
      ['%a, %-I %p', function (d) { return d.getHours(); }],
      ['%b %d', function () { return true; }]
    ]);

    return {
      getChartOptions : getChartOptions
    };

    function getChartOptions(metric) {
      switch (metric.metric) {
        case 'sessions':
        case 'checkouts':
        case 'revenue':
        case 'users':
        case 'revenuePerVisit':
        case 'returnUnits':
        case 'orderUnits':
        case 'returnRate':
          return setupLineChart(metric);
          break;
        case 'conversionRate':
          return setupDeltaSigmaChart(metric);
          break;
        default:
          throw new Error('Unsupported metric type: ' + metric.metric);
      }
    }

    function dateTimeFormat(time) {
      return new Date(time).toLocaleString();
    }

    function domainTipText(d) {
      return [$translate.instant('analytics.series.domain'), dateTimeFormat(this.fn.x(d))];
    }

    function percentFormat(y) {
      return percentFilter(y, 2);
    }

    function currencyFormatter(unit) {
      return function (y) {
        return $translate.instant('currency.' + unit, { value : y });
      };
    }

    function setupLineChart(metricData) {
      var series = metricData.series,
          seriesLen = series.length,
          yDomain, yFormat, unit;
      if (seriesLen !== 1) {
        throw new Error('Unexpected number of series: ' + seriesLen);
      }
      series[0].tipText = function (d) {
        var y = this.fn.y(d);
        return yFormat ? yFormat(y) : y;
      };

      unit = series[0].unit;
      if (unit === 'percent') {
        yFormat = percentFormat;
        // force the y-axis to be centered around 0
        yDomain = 'centered';
      } else {
        if (unit) {
          yFormat = currencyFormatter(unit);
        }
        // force the y-axis to start at 0
        yDomain = { min : 0 };
      }

      return {
        chartOptions : {
          yDomain : yDomain,
          domainTipText : domainTipText,
          yFormat : yFormat,
          xFormat : defaultXFormat
        }
      };
    }

    function setupDeltaSigmaChart(metricData) {

      metricData.series[0].tipText = function (d) {
        var plot = this;
        return percentFormat(plot.fn.y(d)) + ' &plusmn; ' + percentFormat(plot.fn.sigma(d));
      };

      return {
        chart : 'DeltaSigma',
        chartOptions : {
          domainTipText : domainTipText,
          yFormat : percentFormat,
          xFormat : defaultXFormat,
          yDomain : 'centered',
          fn : {
            // todo: this will eventually be a property of the experiment
            // the confidence threshold factor
            confidence : function (d) { return 1.96; }
          }
        }
      };
    }
  }

})();
